<template>
  <div class="early-account-suggest">
    <div class="title-box">
      <p class="title">投放建议<span class="suggest-overview">{{suggestOverview}}</span></p>
      <a class="suggest-link" href="/v2/dist/suggest.html" target="_blank" rel="opener">前往投放建议页查看完整内容<i class="el-icon-arrow-right"></i></a>
    </div>
    <div class="suggest-box basic" v-if="basicList.length">
      <div class="suggest-type">
        <p class="type-title">基础</p>
        <p class="type-desc">投前准备</p>
      </div>
      <div class="suggest-list">
        <div class="suggest-item" v-for="item in basicList" :key="item.key">
          <p class="item-title"><i class="i-icon s-icon icon-warn"></i>{{item.value}}</p>
          <a class="item-link" v-if="item.key == 'KEEP_BALANCE_ENOUGH' && hasCharge || item.key != 'KEEP_BALANCE_ENOUGH'" :href="getLink(item)" target="_blank" rel="opener">{{item.btnLabel}}</a>
        </div>
      </div>
    </div>
    <div class="suggest-box advanced" v-if="advancedList.length">
      <div class="suggest-type">
        <p class="type-title">进阶</p>
        <p class="type-desc">数据对接</p>
      </div>
      <div class="suggest-list">
        <div class="suggest-item" v-for="item in advancedList" :key="item.key">
          <p class="item-title"><i class="i-icon s-icon icon-warn"></i>{{item.value}}</p>
          <a class="item-link" v-if="item.key == 'KEEP_BALANCE_ENOUGH' && hasCharge || item.key != 'KEEP_BALANCE_ENOUGH'" :href="getLink(item)" target="_blank" rel="opener">{{item.btnLabel}}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {getAccountInfo, getCrowPkgLink} from '../utils/api.js';
  const BTN_LABEL = {
    KEEP_BALANCE_ENOUGH: '前往充值',
    TO_MARKET_COURSE: '前往查看',
    TO_ASSET_REPO: '前往上传',
    OCPX_TO_CREATE_CONV: '前往创建',
    DMP_TO_CREATE_DIRECTION: '前往创建'
  };
  const BTN_LINK = {
    KEEP_BALANCE_ENOUGH: '/v2/dist/finance.html#/recharge',
    TO_MARKET_COURSE: '/v2/dist/course.html',
    TO_ASSET_REPO: '/v2/dist/assets.html#/mine/assets/image',
    OCPX_TO_CREATE_CONV: '/v2/dist/tools.html#/conversion-tracking/mobile',
    DMP_TO_CREATE_DIRECTION: 'javascript:void(0);'
  };
  export default {
    name: 'early-account-suggest',
    props: {
      adIssueMap: Object,
      suggestOverview: String
    },
    data() {
      return {
        hasCharge: true,
        dmpLink: location.origin + '/v2/dist/tools2.html#!/tools/list'
      };
    },
    computed: {
      basicList() {
        const list = this.adIssueMap ? this.adIssueMap.BASIC || [] : [];
        return list.map(item => {
          return {
            ...item,
            btnLabel: BTN_LABEL[item.key],
            link: BTN_LINK[item.key]
          };
        });
      },
      advancedList() {
        const list = this.adIssueMap ? this.adIssueMap.ADVANCED || [] : [];
        return list.map(item => {
          return {
            ...item,
            btnLabel: BTN_LABEL[item.key],
            link: BTN_LINK[item.key]
          };
        });
      }
    },
    created() {
      this.getAccountInfo();
      this.getDmpLink();
    },
    methods: {
      async getAccountInfo() {
        const accountInfo = await getAccountInfo();
        if (accountInfo) {
          this.hasCharge = accountInfo.accountCommonInfo.permission.includes('customer.recharge');
        }
      },
      getLink(it) {
        if (it.key != 'DMP_TO_CREATE_DIRECTION') return it.link;
        return this.dmpLink;
      },
      async getDmpLink() {
        let result = await getCrowPkgLink();
        if (result && result.match(/^https?:\/\//)) {
          this.dmpLink = result;
        }
      }
    }
  }
</script>
<style lang="scss">
  .early-account-suggest {
    padding: 25px 24px 20px 24px;
    background-color: #fff;
    border-radius: 14px;
    .title-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      .title {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        line-height: 22px;
        .suggest-overview {
          padding-left: 6px;
          font-size: 14px;
          color: #8C93B0;
          font-weight: 400;
        }
      }
      .suggest-link {
        font-weight: 600;
      }
    }
    .suggest-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 18px 44px;
      border-radius: 12px;
      margin-bottom: 14px;
      &.basic {
        background: linear-gradient(90deg, #FCECEE 0%, #FFFFFF 100%);
        .type-title {
          color: #D72121;
        }
        .icon-warn {
          color: #D72121;
        }
      }
      &.advanced {
        margin-bottom: 0;
        background: linear-gradient(90deg, #ECF3FC 0%, #FFFFFF 100%);
        .type-title {
          color: #3258DD;
        }
        .icon-warn {
          color: #3258DD;
        }
      }
      .suggest-type {
        text-align: center;
        .type-title {
          font-size: 20px;
          font-weight: 600px;
          line-height: 24px;
        }
        .type-desc {
          font-size: 14px;
          line-height: 22px;
          font-weight: 400;
          color: #00000066;
        }
      }
      .suggest-list {
        flex: 1;
        margin-left: 40px;
      }
      .suggest-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        line-height: 22px;
        font-weight: 500;
        margin-bottom: 7px;
        &:last-child {
          margin-bottom: 0;
        }
        .item-title {
          display: flex;
          align-items: center;
        }
        .icon-warn {
          padding-right: 6px;
          font-size: 22px;
        }
        .item-link {
          display: block;
          width: 84px;
          height: 28px;
          line-height: 28px;
          background: #F2F5FD;
          border-radius: 14px;
          color: #3258DD;
          text-align: center;
        }
      }
    }
  }
</style>
